<button (click)="onFavoriteClick($event)" [disabled]="isLoading"
  class="group/fav w-9 h-9 bg-white/90 backdrop-blur-md rounded-full flex items-center justify-center border border-slate-100 shadow-sm transition-all duration-300 hover:bg-white hover:scale-110 active:scale-95 disabled:opacity-50 disabled:pointer-events-none"
  [attr.aria-label]="isFavorite ? 'Remove from favorites' : 'Add to favorites'">

  @if (isLoading) {
  <i class="fa-solid fa-circle-notch animate-spin text-xs text-slate-400"></i>
  } @else {
  <i [class]="isFavorite 
        ? 'fa-solid fa-heart text-primary scale-105 drop-shadow-[0_2px_4px_rgba(228,87,5,0.35)]' 
        : 'fa-regular fa-heart text-slate-700 transition-transform duration-200 group-hover/fav:scale-110 group-hover/fav:text-primary'"
    class="text-[15px] transition-all duration-300">
  </i>
  }
</button>
<!-- 
<app-not-logged-in
  [isVisible]="showLoginPopup"
  [title]="'تسجيل الدخول مطلوب'"
  [message]="'يجب تسجيل الدخول لإضافة العقارات إلى المفضلة'"
  (close)="closeLoginPopup()"
></app-not-logged-in> -->